function tidyAtRule(value) {
  return value
    .replace(/\s+/g, ' ')
    .replace(/url\(\s+/g, 'url(')
    .replace(/\s+\)/g, ')')
    .trim();
}

module.exports = tidyAtRule;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/optimizer/level-1/tidy-at-rule.js
// module id = 676
// module chunks = 0 1